/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Speakers_Menu_LabelInputs */

const en_speakers_menu_label = /** @type {(inputs: Speakers_Menu_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show menu`)
};

const fr_speakers_menu_label = /** @type {(inputs: Speakers_Menu_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show menu`)
};

const de_speakers_menu_label = /** @type {(inputs: Speakers_Menu_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show menu`)
};

const it_speakers_menu_label = /** @type {(inputs: Speakers_Menu_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show menu`)
};

const ru_speakers_menu_label = /** @type {(inputs: Speakers_Menu_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show menu`)
};

const es_speakers_menu_label = /** @type {(inputs: Speakers_Menu_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show menu`)
};

const zh_cn2_speakers_menu_label = /** @type {(inputs: Speakers_Menu_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show menu`)
};

const ja_speakers_menu_label = /** @type {(inputs: Speakers_Menu_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show menu`)
};

const hi_speakers_menu_label = /** @type {(inputs: Speakers_Menu_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show menu`)
};

const pt_pt2_speakers_menu_label = /** @type {(inputs: Speakers_Menu_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show menu`)
};

/**
* | output |
* | --- |
* | "Show menu" |
*
* @param {Speakers_Menu_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const speakers_menu_label = /** @type {((inputs?: Speakers_Menu_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Speakers_Menu_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_speakers_menu_label(inputs)
	if (locale === "de") return de_speakers_menu_label(inputs)
	if (locale === "it") return it_speakers_menu_label(inputs)
	if (locale === "ru") return ru_speakers_menu_label(inputs)
	if (locale === "es") return es_speakers_menu_label(inputs)
	if (locale === "zh-CN") return zh_cn2_speakers_menu_label(inputs)
	if (locale === "ja") return ja_speakers_menu_label(inputs)
	if (locale === "hi") return hi_speakers_menu_label(inputs)
	if (locale === "pt-PT") return pt_pt2_speakers_menu_label(inputs)
	return en_speakers_menu_label(inputs)
});